'use client';

import { ReviewsGrid as Grid } from 'components/reviews-grid/reviews-grid';
import { useTranslation } from 'next-i18next';
import * as Reviews from './reviews';
function ReviewsGrid() {
  const {
    t,
    i18n
  } = useTranslation('features-teams');
  const backgroundImage = `${process.env.NEXT_PUBLIC_BASE_URL}/static/workspaces/social-proof/review-grid-background.png`;
  return <Grid backgroundImage={backgroundImage} data-sentry-element="Grid" data-sentry-component="ReviewsGrid" data-sentry-source-file="reviews-grid.tsx">
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Reviews.ReviewEvnsio t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
                <Reviews.ReviewAeravi t={t} lang={i18n.language} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Reviews.ReviewKaiinde t={t} lang={i18n.language} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
                <Reviews.ReviewNotJulien t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Reviews.ReviewSaschafrommars t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
                <Reviews.ReviewNJRun t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Reviews.ReviewDayOneUser t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
                <Reviews.ReviewIammoinak t={t} data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
        </Grid>;
}
export { ReviewsGrid };